/**
 * @namespace Abstracts
 */
import Backbone from 'backbone'

/**
 * Classe responsável por gerenciar um estado de uma entidade
 * Todos os valores adicionados nesse model são arrays
 * @name Entity
 * @memberof abstracts/status
 * @extends Backbone.Model
 * @see {@link https://backbonejs.org/#Model}
 */
class Entity extends Backbone.Model {
    /**
     * Varre os atributos enviados pelo new e os reescrevem como um array
     *
     * @return {void}
     */
    initialize () {
        for (const status of Object.keys(this.attributes)) {
            super.set(status, [super.get(status)])
        }
    }

    /**
     * Seta um novo item no array daquele status
     *
     * @param {string} status - Nome do Estado
     * @param {string} value - Valor do Estado
     * @return {void}
     */
    set (status, value) {
        const arr = this.getAll(status) || []
        arr.push(value)
        super.set(status, arr)
    }

    /**
     * Retorna o último item do array do status
     *
     * @param {string} status - Nome do Estado
     * @return {string} - Estado
     */
    get (status) {
        const arr = this.getAll(status) || []
        if (arr.length === 0) {
            return false
        }

        return arr[arr.length - 1]
    }

    /**
     * Retorna todo o histórico do array
     *
     * @param {string} status - Nome do Estado
     * @return {array} - Histórico
     */
    getAll (status) {
        return super.get(status)
    }
}

export default Entity
